// // store/useCouponStore.js
// import { create } from 'zustand';

// const useCouponStore = create((set) => ({
//     totalPriceWithCoupon: 0, // default value
//     setTotalPriceWithCoupon: (value) => set({ totalPriceWithCoupon: value }),
//     resetTotalPriceWithCoupon: () => set({ totalPriceWithCoupon: 0 }),
// }));

// export default useCouponStore;



// store/useCouponStore.js
import { create } from 'zustand';

const useCouponStore = create((set) => ({
    couponData: {
        isPassed: false,
        finalPrice: 0,
        discountAmount: 0,
        couponCode: "",
    },
    setCouponData: (data) => set({ couponData: { ...data } }),
    resetCouponData: () => set({ couponData: { isPassed: false, finalPrice: 0, discountAmount: 0, couponCode: "" } }),
}));

export default useCouponStore;

